// extracted by mini-css-extract-plugin
export default {"bundleRewardsWrapper":"xRgIr6uTFcdAea_zrCMw","bundleReward":"AREZnLgDPptOu5JoThbl","plusSeparator":"fX0loeTBXYczg42yUDmX","text":"Gz_qS8rBRbsA3MhIypfq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"bundleRewardsWrapper\":\"xRgIr6uTFcdAea_zrCMw\",\"bundleReward\":\"AREZnLgDPptOu5JoThbl\",\"plusSeparator\":\"fX0loeTBXYczg42yUDmX\",\"text\":\"Gz_qS8rBRbsA3MhIypfq\"}";
        // 1755964994677
        var cssReload = require("../../../../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  